import React, { Component } from 'react'
import { Link, Switch, Route } from 'react-router-dom'
import './main.css'
import dia from './diamond.png'
import kitobimg1 from './livebook.jpg'


class Book extends Component {
    
    state = {
        kitob1: [{
            name: "Living in the Light: A guide to personal transformation",
            pages: "258 Pages / 2001 / 2.74 MB / 616,200 downloads",
            word: "Transformation / Shakti Gawain, with Lurel King. - Completely rev such as The Path of Transformation"
        }],
        kitob2: [{
            name: "Give and Take: Why helping others drives our success",
            pages: "260 pages / 2011 / 1.57 MB /  680,415 downloads",
            word: "Give and Take is brimming with life-changing insights. One of the great secrets of life is that those who "
        }],
        keyword: "",
        ochiq: false
    }
    handleQidiruv = (event) => {
        this.setState({
            keyword: event.target.value
        })
    }

    handlemoreinfo = () => {
        this.setState({
            ochiq: !this.state.ochiq
        })
    }
    componentDidMount(){
        console.log(this.props)
    }
    render() {
        return (
            <React.Fragment>


            </React.Fragment>
        )
    }
}
export default Book






